import { createFileRoute } from '@tanstack/react-router'
import { RequireAuth } from '@dss/auth'
import { WorkspaceEntry } from '../features/session/WorkspaceEntry'

/** D48: текущая DB роль выбирает поддержанную функцию, не legacy dashboard. */
export const Route = createFileRoute('/')({
  component: () => <RequireAuth><WorkspaceEntry /></RequireAuth>,
})
